import { LoginStatusState } from '@core/login-status/store/states/login-status.state';

export const loginStatusState = [LoginStatusState];
